import React, { useEffect } from 'react'
import './Coupon_Card.css'
import Green_Btn from '../common_btn/green_btn/Green_Btn'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { getCoupons } from '../../../features/home/homeSlice'
import { useDispatch, useSelector } from 'react-redux'

const Coupon_Card = ({val,data, showtc,handelSubmit }) => {
    const dispatch = useDispatch();
  
    return (
        <section className='Coupon_Card'>
            <div className='top_div'>
                <div className='left_side'>
                    <img src='/assets/images/checkout/discount.png' className='discount_img' />
                    <p className='coupon_code'>{val?.name}</p>
                </div>
                <div className='apply_div'>
                    <Green_Btn btn_name="Apply" onClick={() => handelSubmit(val)} />
                </div>
            </div>

            <div className='content_text_div'>
                <p className='main_text'> Save ₹
                  {val?.Discount_Type?.id === 2
                    ? (
                        ((data?.total_selling_price || 0) *
                          (val?.discount || 0)) /
                        100
                      ).toFixed(2)
                    : parseFloat(val?.discount || 0).toFixed(2)}{" "}
                  on this order!</p>

                <ul>
                     <li className='point_text'> Flat{" "}
                    {val?.Discount_Type?.id === 2
                      ? `${val?.discount}%`
                      : val?.discount}{" "}</li>
                    <li className='point_text'>{val?.info}</li>
                    <li className='point_text'>{val?.message}</li>
                    <li className='point_text'>Valid on minimum purchase of ₹{val?.required_amount}{" "}</li>
               
                </ul>

                {showtc && (
                    <div className='tc_div'>
                        <p className='tc_text'>Terms & Conditions <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" /></p>
                    </div>
                )}



            </div>

        </section>
    )
}

export default Coupon_Card
